var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dologin-wrapper"},[(_vm.errorMessage)?_c('div',{staticClass:"dologin-error-card"},[_c('div',{staticClass:"dologin-error-icon"},[_vm._v("⚠")]),_c('p',{staticClass:"dologin-error-text"},[_vm._v(_vm._s(_vm.errorMessage))])]):_c('div',{staticClass:"dologin-redirecting"},[_vm._v(_vm._s(_vm.$t("redirecting.text")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }